



































































import IOutbound from '@/store/models/IOutbound';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import Snackbar from '@/components/shared/Snackbar.vue';
import moment from 'moment';
import IOutboundDetail from '@/store/models/IOutboundDetail';

@Component({
    components: {
        Snackbar
    }
})
export default class CustomerOutboundsSelector extends Vue {
    searchOutbound: string = "";
    headers: any = [
        { text: 'Company Source', align: 'start', value: 'companySourceName' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Code', value: 'code' },
        { text: 'Date Out', value: 'dateOut' },
        { text: 'Status', value: 'statusName' }
    ];
    headersOutboundDetail: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Best before date', value: 'bestBeforeDate' }
    ];

    @Prop({ type: Array, required: true })
    OutboundList !: IOutbound[];
    @Prop({ type: Array, required: true })
    OutboundDetailList !: IOutboundDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedOutbound: IOutbound[] = [];
    dateIn: string = new Date().toISOString().substr(0, 10);

    @Watch('selectedOutbound')
    onChangeOutbound() {
        this.$emit('outboundChanged', this.selectedOutbound[0]);
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
